export const DOWNLOAD_IOS_APP = "https://apps.apple.com/us/app/melanated-health/id1533563884";

export const DOWNLOAD_ANDROID_APP = "https://play.google.com/store/apps/details?id=com.RuniT.MelanatedHealth&hl=en_US&gl=US"